import React from "react";
import dayjs from "dayjs";
import "./RareFind.scss";
// import IconDiamond from 'venuescanner-js/react/components/Objects/Icons/IconDiamond';

export const RareFind = ({ thread }) => {
  function hasQuoteBeenReceivedWithin48Hours(thread) {
    const lastOfferTimestamp = thread.lastMessageWithOffer?.sendAt;

    return (
      lastOfferTimestamp &&
      dayjs().isSameOrBefore(dayjs(lastOfferTimestamp).add(48, "hour"))
    );
  }

  return (
    <div className="rare-find">
      {/* <div className="rare-find_icon">
        <IconDiamond aria-hidden="true" focusable="false" /> <p>Rare Find</p>
      </div> */}
      {hasQuoteBeenReceivedWithin48Hours(thread) && (
        <div className="rare-find_chip">
          <p>Guaranteed for 48 hours</p>
        </div>
      )}
    </div>
  );
};
